import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectFilesButton"]

  connect() {
    // This select may or may not exist
    this.fileTypeSelect = this.element.querySelector("select");
    // The file input is always there
    this.fileInput = this.element.querySelector("input[type=file]");
  }

  fileTypeChanged(e) {
    this.fileTypeSelect.dataset.placeholder = false;
    this.selectFilesButtonTarget.classList.remove("hidden");
  }

  selectFiles(e) {
    e.preventDefault();
    this.fileInput.click();
  }

  fileChanged(e) {
    if (this.element.getAttribute("data-submit-on-select") == "true") {
      // For some reason requestSubmit doesn't work, so our workaround is to trigger a click event on the submit button.
      // e.target.form.requestSubmit();
      var formSubmitButton = e.target.form.querySelector("[type=submit]");
      formSubmitButton.click();
      formSubmitButton.disabled = true;

      if (this.selectFilesButtonTarget) {
        if (this.element.getAttribute("data-update-button-text") != "false") {
          this.selectFilesButtonTarget.innerHTML = "Uploading...";
        }

        this.selectFilesButtonTarget.disabled = true;
      }
    }
  }
}